import { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './AutoCadastroUsuario.css';
import { OrgaoUsuarioSiape } from "./EditSiape";
import { isCNPJ } from '../../utils/cnpjValidation';
import {DIRIGENTE_TI, RESPONSAVEL_TECNICO} from '../../providers/constAtribuicoesGestor';
import { ConfirmEmailModal } from "../ConfirmEmailModal/ConfirmEmailModal";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { ButtonBack } from "../Button/Back";
import { strTobase64, base64ToStr  } from "../../utils/base64Util";
import { FEDERAL, ESTADUAL, MUNICIPAL, ID_ESTADUAL, ID_MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { AutoCadastroUsuarioHistory } from "./History";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import { ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA } from "../../providers/constSituacoesAutoCadastroUsuario";
import { ModalIntrucoesAtribuicao } from "./ModalIntrucoesAtribuicao";
import { maskedCnpjInput } from '../../utils/maskUtil';

import { faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const AutoCadastroUsuarioEdit =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				solicitacao: {
					id: '',
					nomeUsuario: '',
					emailUsuario: '',
					orgaoExercicioUsuario: '',
					uorgLotacaoUsuario: '',
					uorgExercicioUsuario: '',
					siape: false,
					orgao: '',
					esferaAdministrativaOrgao: '',
					nomeEsferaAdministrativaOrgao: '',
					codigoMunicipioIBGEOrgao: '',
					nomeMunicipioIBGEOrgao: '',
					atribuicaoUsuario: '',
					cnpjOrgao: '',
					siglaOrgao: '',
					alteracaoPermitida: true,
					justificativa: '',
				},
				consultaOrgao: {
				},
				emailOriginalUsuario: '',
				atribuicoesGestor: [DIRIGENTE_TI, RESPONSAVEL_TECNICO],
				esferasAdministrativas: [ESTADUAL, FEDERAL, MUNICIPAL],
				botoesHabilitados : true,
				carregandoDadosUsuario: false,
				carregandoOrgao: false,
				exibeModalConfirmacaoEmail: false,
				exibeModalConfirmacao: false,
				exibeModalInstrucao: false,
				exibeModalLiberaAssinatura: false,
				msgModal: '',
			};
			this.state=this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.pesquisarOrgao = this.pesquisarOrgao.bind(this);
			this.salvar = this.salvar.bind(this);
			this.validaFormulario = this.validaFormulario.bind(this);
			this.fecharModais = this.fecharModais.bind(this);
			this.enviarCodigoVericacaoEmail = this.enviarCodigoVericacaoEmail.bind(this);
			this.liberaAssinatura = this.liberaAssinatura.bind(this);
			this.deferirSolicitacao = this.deferirSolicitacao.bind(this);
			this.rejeitarSolicitacao = this.rejeitarSolicitacao.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Cadastro de Usuário</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			this.props.mostraAguardando()
			const user = this.props.user;

			let url = '/api/auto-cadastro-usuario';
			if(!user.isAnonimo) {
				const id = this.props.match.params.id;
				url += `/${id}`;
			}

			api.get(url)
				.then(response => { 
					const solicitacao = response.data;
					const emailOriginalUsuario = solicitacao.emailUsuario;
					this.pesquisarOrgao(solicitacao.cnpjOrgao);
					this.setState(
						{
							solicitacao,
							emailOriginalUsuario,
						}) 
				})
				.catch(erro => {
					if(user.isAnonimo && erro.status === 404){
						this.carregaDadosUsuario();
					} else {
						const msg = getMessagemErro("Não foi possível consultar a solicitacao.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					}
				})
				.finally(() => {
					this.props.escondeAguardando();
				});

				if (localStorage.getItem('stateParent') && 
					localStorage.getItem('stateParentUrl') && 
					localStorage.getItem('stateParentUrl') === this.props.location.pathname) {
					const stateParent = JSON.parse(base64ToStr(localStorage.getItem('stateParent')));
					this.setState({...this.initialState, ...stateParent})
					localStorage.removeItem('stateParent');
					localStorage.removeItem('stateParentUrl');
				} 

		}

		carregaDadosUsuario() {
			this.props.limpaMensagem();
			this.setState ({carregandoDadosUsuario: true})
			api.get('/api/auto-cadastro-usuario/dados-usuario')
				.then(response => { 

					const { cpf, nome, email, orgaoExercicio, uorgLotacao, uorgExercicio, siape } = response.data;
					const solicitacao = this.state.solicitacao;
					solicitacao['id'] =  cpf;
					solicitacao['nomeUsuario'] = nome;
					solicitacao['emailUsuario'] = email;
					solicitacao['orgaoExercicioUsuario'] = orgaoExercicio;
					solicitacao['uorgLotacaoUsuario'] = uorgLotacao;
					solicitacao['uorgExercicioUsuario'] = uorgExercicio;
					solicitacao['siape'] = siape;
					this.setState(
						{
							solicitacao,
						}) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível consultar o servidor.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState ({carregandoDadosUsuario: false})
				});
		}

		renderForm() {
			const user = this.props.user;
			const { solicitacao, consultaOrgao, carregandoDadosUsuario, carregandoOrgao, esferasAdministrativas } = this.state;
			const { esferaAdministrativaOrgao, nomeEsferaAdministrativaOrgao, codigoMunicipioIBGEOrgao, nomeMunicipioIBGEOrgao } = solicitacao;

			const codigoMunicipioIBGE =  this.getCodigoIBGEFormatado(codigoMunicipioIBGEOrgao, esferaAdministrativaOrgao);
			const nomeMunicipioIBGE = this.getNomeMunicipio(nomeMunicipioIBGEOrgao, esferaAdministrativaOrgao);

			const mensagem = `Foi enviado um código de verificação para o email ${solicitacao.emailUsuario}. Informe-o no campo abaixo:`;

			const edicaoPermitida = solicitacao.alteracaoPermitida || (user.isAdministrador && solicitacao.analisePermitida);

			return(
				<div className="container-fluid">
					<ConfirmEmailModal titulo="Verificação do Email" 
						visible={this.state.exibeModalConfirmacaoEmail}
						handleOk={this.salvar}
						handleCancel={this.fecharModais}
						handleReenviar={this.enviarCodigoVericacaoEmail}
						message={mensagem} />

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalConfirmacao}
						handleOk={() => this.executaOperacao()}
						handleCancel={this.fecharModais}
						message={this.state.msgModal}/>

					<ModalIntrucoesAtribuicao
						titulo="Instruções para preenchimento do campo atribuição" 
						visible={this.state.exibeModalInstrucao}
						handleClose={() => this.setState({exibeModalInstrucao: false})}
					/>

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalLiberaAssinatura}
						handleOk={this.liberaAssinatura}
						handleCancel={() => this.setState({exibeModalLiberaAssinatura: false})}
						okText= "Sim"
						cancelText= "Não"
						icon={faTriangleExclamation}
						iconColor= "#FFCD07"
						message="Solicitação salva com sucesso!">
							<p>Para enviar a sua solicitação de cadastro para análise é necessário assinar o termo de responsabilidade.</p>
							<p>Deseja assiná-lo agora?</p>
					</ConfirmModal>

					<div className="br-form">
						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label>CPF:</label>
										<input value={solicitacao.id} disabled/>
										{carregandoDadosUsuario === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Nome:</label>
										<input value={solicitacao.nomeUsuario} disabled/>
									</div>
								</div>
							</div>
							{ solicitacao.situacao &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label>Situação:</label>
											<input value={solicitacao.nomeSituacao} disabled/>
										</div>
									</div>
								</div>
							}

						</div>

						{solicitacao.siape === true &&
							<OrgaoUsuarioSiape solicitacao={solicitacao} />
						}

						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label>Email Institucional:</label>
										<input type="email" value={solicitacao.emailUsuario} name="emailUsuario" onChange={this.handleInputChange} disabled={!edicaoPermitida}/>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-sm-2 mr-1 pr-1">
								<div className="field">
									<div className="input">
										<label htmlFor="cnpjOrgao">CNPJ do seu Órgão:</label>
										<input type="text" name="cnpjOrgao" maxLength="18"
											value={maskedCnpjInput(solicitacao.cnpjOrgao)}  
											onChange={(e) => {
												e.target.value = e.target.value.replace(/[.\-/]/g, "");
												this.handleInputChange(e);
											}
											}
											disabled={!edicaoPermitida}
											/>
									</div>
								</div>
							</div>

							{ edicaoPermitida && 
								<div className="d-flex align-items-end ml-0 pl-0">
									<div className="actions-button">
										<div className="actions">
											<div>
												<button type="button" className="button is-secondary" onClick={() => this.pesquisarOrgao(solicitacao.cnpjOrgao)}>Pesquisar</button>
												{carregandoOrgao === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
											</div>
										</div>
									</div>
								</div>
							}
						</div>

						{ consultaOrgao.orgaos && consultaOrgao.orgaos.length > 0 &&
							<div className="row">
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="orgao">Órgão:</label>						
										</div>
										<div className="input">
											{consultaOrgao.orgaos.length > 0 && 
												<SelectSearch
													id="orgao"
													name="orgao"
													options={consultaOrgao.orgaos.map(orgao => ({value: orgao.id, label: `${orgao.nome} - ${orgao.sigla} (${orgao.nomeEsferaAdministrativa} - ${orgao.uf})`}))}
													onChange={this.handleOrgaoChange}
													value={solicitacao.orgao}
													disabled={!edicaoPermitida}		
												/>
											}
										</div>
									</div>
								</div>
							</div>
						}

						{ consultaOrgao.orgaos && consultaOrgao.orgaos.length === 0 && consultaOrgao.orgao &&
							<Fragment>
								<div className="row">
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>Nome:</label>
												{ !solicitacao.analisePermitida &&
													<input value={consultaOrgao.orgao.nomeEmpresarial} disabled/>
												}

												{ solicitacao.analisePermitida &&
													<input type="text" name="nomeOrgao" maxLength="100" value={solicitacao.nomeOrgao} onChange={this.handleInputChange} />
												}
											</div>
										</div>
									</div>
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="siglaOrgao">Sigla:</label>
												<input type="text" name="siglaOrgao" maxLength="50"
													value={solicitacao.siglaOrgao}  
													onChange={this.handleInputChange}
													disabled={!edicaoPermitida}
													/>
											</div>
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-sm">
										<div className="field">
											<div className="input">
												<label>Esfera Administrativa:</label>
												{consultaOrgao.orgao.esferaAdministrativa &&
													<input value={nomeEsferaAdministrativaOrgao} disabled/>
												}

												{! consultaOrgao.orgao.esferaAdministrativa &&
													<SelectSearch
														id="esferaAdministrativaOrgao"
														name="esferaAdministrativaOrgao"
														options={esferasAdministrativas.map(esfera => ({value: esfera.codigo, label: esfera.nome}))}
														onChange={this.handleInputChange}
														value={esferaAdministrativaOrgao}
														disabled={!edicaoPermitida}		
													/>
												}
											</div>
										</div>
									</div>
									<div className="col-sm">
										<div className="field">
											<div className="input">
												<label>Unidade da Federação:</label>
												<input value={consultaOrgao.orgao.endereco.uf} disabled/>
											</div>
										</div>
									</div>
								</div>
							</Fragment>
						}


						{ esferaAdministrativaOrgao && (esferaAdministrativaOrgao === ID_ESTADUAL || esferaAdministrativaOrgao === ID_MUNICIPAL) &&
							<>
								<div className="row">
									{ esferaAdministrativaOrgao === ID_MUNICIPAL &&
										<div className="col-md">
											<div className="field">
												<div className="input">
													<label htmlFor="nomeMunicipioIBGE">Município:</label>
													<input type="text" name="nomeMunicipioIBGE" 
														value={nomeMunicipioIBGE}
														disabled={true}
														/>
												</div>
											</div>
										</div>
									}
									<div className="col-sd">
										<div className="field">
											<div className="input">
												<label htmlFor="codigoMunicipioIBGE">Código IBGE:</label>
												<input type="text" name="codigoMunicipioIBGE" 
													value={codigoMunicipioIBGE}
													disabled={true}
													/>
											</div>
										</div>
									</div>
								</div>
							</>
						}

						{ (consultaOrgao.orgaos || consultaOrgao.orgao) &&
							<div className="row">
								<div className="col-sm-2">
									<div className="field">
										<div className="input">
											<label htmlFor="atribuicaoUsuario">
												Atribuição:
												<button type="button" className="ajuda-button" title="Exibe instruções para o preenchimento do campo atribuição" onClick={() => this.setState({exibeModalInstrucao: true})}>
													<span className="sr-only">Exibe instruções para preenchimento do campo atribuição</span>
													<i className="fas fa-question"></i>
												</button>
											</label>	
											<SelectSearch
												id="atribuicaoUsuario"
												name="atribuicaoUsuario"
												options={this.state.atribuicoesGestor.map(atribuicao => ({value: atribuicao.codigo, label: atribuicao.nome}))}
												onChange={this.handleInputChange}
												value={solicitacao.atribuicaoUsuario}
												disabled={!edicaoPermitida}		
											/>
										</div>
									</div>
								</div>
							</div>
						}
						{(! user.isAnonimo || Number(solicitacao.situacao) === ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA) && 
							<div className="row">
								<div className="col-md">  
									<div className="field">
										<div className="input"> 
											<label htmlFor="justificativa">Justificativa de rejeição:</label>
											<textarea name="justificativa" value={solicitacao.justificativa} 
												onChange={this.handleInputChange} maxLength={500} style={{height:"90px"}}
												disabled={! solicitacao.analisePermitida}/>
										</div>
									</div>
								</div>
							</div>
						}

						{solicitacao.situacao &&
							<div className="row">
								<div className="col-md">
								</div>
								<div className="col-sm-4">
									<div className="field">
										<div className="input">
											<label>Histórico:</label>
											{solicitacao.id &&
												<AutoCadastroUsuarioHistory solicitacao={solicitacao} user={user} key={solicitacao.situacao}/>
											}
										</div>
									</div>
								</div>
							</div>
						}

						{/* button actions */}
						<div className="actions-button">
							<div className="actions justify-content-start">
								{ solicitacao.alteracaoPermitida && 
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>Salvar</button>
								}

								{ (solicitacao.liberacaoAssinaturaPermitida || solicitacao.assinaturaPermitida) && 
									<button type="button" className="button is-secondary" onClick={this.liberaAssinatura} disabled={!this.state.botoesHabilitados}>Assinar</button>
								}

								{solicitacao.analisePermitida && 
									<Fragment>
										<button type="button" className="button is-primary" onClick={() => this.confirmaOperacao(this.deferirSolicitacao, "Deseja realmente deferir a solicitação de cadastro de usuário?")}  disabled={!this.state.botoesHabilitados}>Deferir</button>
										
										<button type="button" className="button is-secondary" onClick={() => this.confirmaOperacao(this.rejeitarSolicitacao, "Deseja realmente rejeitar a solicitação de cadastro de usuário?")}  disabled={!this.state.botoesHabilitados}>Rejeitar</button>
									</Fragment>
								}

								{! user.isAnonimo && 
									<ButtonBack disabled={!this.state.botoesHabilitados} />
								}
							</div>
						</div>

					</div>	
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			const solicitacao = this.state.solicitacao;

			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleOrgaoChange(evento){
			const idOrgao = evento.target.value;
			const solicitacao = this.state.solicitacao;

			solicitacao['orgao'] = idOrgao;
			solicitacao['codigoMunicipioIBGEOrgao'] = '';
			solicitacao['nomeMunicipioIBGEOrgao'] = '';
			
			if(idOrgao){
				const orgao = this.state.consultaOrgao.orgaos.find(orgao => orgao.id === idOrgao);
				const esferaAdministrativaOrgao = orgao.esferaAdministrativa;
				solicitacao['esferaAdministrativaOrgao'] = esferaAdministrativaOrgao;
				solicitacao['codigoMunicipioIBGEOrgao'] = orgao.codigoMunicipioIBGE;
				solicitacao['nomeMunicipioIBGEOrgao'] = orgao.nomeMunicipioIBGE;
			} 

			this.setState({ solicitacao });
		}

		pesquisarOrgao(cnpjInformado){
			this.props.limpaMensagem();
			if(!isCNPJ(cnpjInformado)){
				this.props.exibeMensagemErro("Informe um CNPJ válido.")
			}else{
				this.setState ({carregandoOrgao: true})
				const solicitacao = this.state.solicitacao;
				solicitacao.orgao = '';
				solicitacao.siglaOrgao = '';
				solicitacao.esferaAdministrativaOrgao = '';
				solicitacao.nomeEsferaAdministrativaOrgao = '';
				solicitacao.codigoMunicipioIBGEOrgao = '';
				solicitacao.nomeMunicipioIBGEOrgao = '';
				this.setState({consultaOrgao: {}, solicitacao})
				api.get(`/api/auto-cadastro-usuario/dados-orgao/${cnpjInformado}`)
				.then(response => { 
					const consultaOrgao = response.data;
					const solicitacao = this.state.solicitacao;
					if(consultaOrgao.orgaos.length === 0 && consultaOrgao.orgao){
						const esferaAdministrativa = consultaOrgao.orgao.esferaAdministrativa;
						const municipio = consultaOrgao.orgao.municipio;
						if (esferaAdministrativa) {
							solicitacao.esferaAdministrativaOrgao = esferaAdministrativa.codigo;
							solicitacao.nomeEsferaAdministrativaOrgao = esferaAdministrativa.descricao;
						}
						if(municipio) {
							solicitacao.codigoMunicipioIBGEOrgao = municipio.codigo;
							solicitacao.nomeMunicipioIBGEOrgao = municipio.descricao;						
						}

					} else if(consultaOrgao.orgaos.length === 1){
						const orgao = consultaOrgao.orgaos[0];
						solicitacao.orgao = orgao.id;
						solicitacao.esferaAdministrativaOrgao = orgao.esferaAdministrativa;
						solicitacao.codigoMunicipioIBGEOrgao = orgao.codigoMunicipioIBGE;
						solicitacao.nomeMunicipioIBGEOrgao = orgao.nomeMunicipioIBGE;
					} 
					this.setState({consultaOrgao, solicitacao});
				})
				.catch(erro => {
					const mensagemInicial = "Não foi possível recuperar os dados do CNPJ informado"
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.setState ({carregandoOrgao: false})
				});
			}
		}

		getNomeMunicipio(nomeMunicipioIBGE, esferaAdministrativa) {
			if(esferaAdministrativa === ID_MUNICIPAL){
				return nomeMunicipioIBGE
			} else {
				return "";
			}

		}

		getCodigoIBGEFormatado(codigoMunicipioIBGE, esferaAdministrativaOrgao){
			if((! codigoMunicipioIBGE )|| (esferaAdministrativaOrgao !== ID_ESTADUAL && esferaAdministrativaOrgao !== ID_MUNICIPAL)){ 
				return "";
			} else if(esferaAdministrativaOrgao === ID_ESTADUAL){
				return codigoMunicipioIBGE.substring(0, 2);
			} else if(esferaAdministrativaOrgao === ID_MUNICIPAL){
				return codigoMunicipioIBGE;
			} else {
				return "";
			}
		}

		fecharModais () {
			this.setState(
				{
					exibeModalConfirmacaoEmail:false,
					exibeModalConfirmacao:false,
				}
			);
		}

		salvar(e, codigoVerificacaoEmail){
			this.props.limpaMensagem();

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const { solicitacao, emailOriginalUsuario  } = this.state;
			if(emailOriginalUsuario !== solicitacao.emailUsuario && !codigoVerificacaoEmail) {
				this.enviarCodigoVericacaoEmail();
				return;
			}

			this.setState({botoesHabilitados:false, exibeModalConfirmacaoEmail: false});
			solicitacao['codigoVerificacaoEmail'] = codigoVerificacaoEmail;
			const url = "/api/auto-cadastro-usuario";

			const options = {
				method: 'put',
				url,
				data : solicitacao,
			}
			this.props.mostraAguardando();
			api(options)
				.then(response => {
					const solicitacao = response.data;
					const emailOriginalUsuario = solicitacao.emailUsuario;
					const exibeModalLiberaAssinatura = true;
					this.setState({ solicitacao,  emailOriginalUsuario, exibeModalLiberaAssinatura})
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.solicitacao.id ? 'alterar' : 'incluir'} a solicitação.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});   

		}

		enviarCodigoVericacaoEmail() {
			const solicitacao = this.state.solicitacao;

			const options = {
				method: 'post',
				url: '/api/auto-cadastro-usuario/envia-codigo-verificacao-email',
				data : solicitacao,
			}
			
			this.props.mostraAguardando();
			api(options)
				.then(response => {
					this.setState( {exibeModalConfirmacaoEmail : true})
				})
				.catch(erro => {
					const mensagemInicial = 'Não foi possível enviar o código de verificação do email ';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});   
		}

		validaFormulario(operacao){
			let mensagens = [];
			const { solicitacao, consultaOrgao} = this.state;

			if( consultaOrgao.orgaos ) {
				if(consultaOrgao.orgaos.length > 0) {
					const idOrgao = solicitacao.orgao;
					if (idOrgao) {
						const orgao = consultaOrgao.orgaos.filter((o) => o.id === Number(idOrgao))[0];

						if(solicitacao.siape && orgao.esferaAdministrativa !== 'F') {
							mensagens.push({'mensagem' : 'Usuário vinculado ao SIAPE só pode se associar a órgãos da esfera federal.'})	
						}

						if(operacao !== this.rejeitarSolicitacao && !solicitacao.siape && orgao.vinculadoSiape) {
							mensagens.push({'mensagem' : 'Usuário não vinculado ao SIAPE não pode se associar a órgãos vinculados ao SIAPE.'}) 	
						}
					} else {
						mensagens.push({'mensagem' : 'Seu órgão obrigatório.'})
					}
				}

				if(consultaOrgao.orgaos.length === 0) {
					if(!solicitacao.siglaOrgao){
						mensagens.push({'mensagem' : 'Sigla obrigatória.'});
					}
					if(! consultaOrgao.orgao.esferaAdministrativa && ! solicitacao.esferaAdministrativaOrgao){
						mensagens.push({'mensagem' : 'Esfera administrativa obrigatória.'})
					}
					if(solicitacao.siape && solicitacao.esferaAdministrativaOrgao && solicitacao.esferaAdministrativaOrgao !== 'F') {
						mensagens.push({'mensagem' : 'Usuário vinculado ao SIAPE só pode se associar a órgãos da esfera federal.'})	
					}
				}
			} else {
				mensagens.push({'mensagem' : 'Informe o CNPJ do seu órgão e execute a pesquisa.'})
			}

			const { emailUsuario, justificativa }  =  solicitacao;
			if(! emailUsuario || emailUsuario.trim().length === 0 ) {
				mensagens.push({'mensagem' : 'Email institucional obrigatório.'})
			}

			if(this.rejeitarSolicitacao === operacao && (!justificativa || justificativa.trim().length === 0)) {
				mensagens.push({'mensagem' : 'Justificativa de rejeição obrigatória.'})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		liberaAssinatura(e, codigoVerificacaoEmail){
			const stateFilters = {
				solicitacao: this.state.solicitacao
			}
			const stateParent = strTobase64(JSON.stringify(stateFilters));
			localStorage.setItem('stateParentUrl', this.props.location.pathname);
			console.log(`Tamanho aproximado: ${stateParent.length * 2} bytes`); // Exemplo: 38 bytes
			localStorage.setItem('stateParent', stateParent);

			this.props.limpaMensagem();
			
			const { solicitacao } = this.state;
			const pathAssinatura = `/user-self-registration/sign/${solicitacao.id}`;
			if(solicitacao.assinaturaPermitida) {
				this.props.history.push(pathAssinatura);
				return;
			}

			let url = "/api/auto-cadastro-usuario/liberar-assinatura";

			const options = {
				method: 'put',
				url,
			}
			this.props.mostraAguardando();
			api(options)
				.then(response => {
					this.props.history.push(pathAssinatura)
				})
				.catch(erro => {
					const mensagemInicial = 'Não foi possível encaminhar a solicitação para assinatura.';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});  
		}

		confirmaOperacao(operacao, msgModal) {
			try{
				this.validaFormulario(operacao);
			}catch(erroValidacao){
				return;
			}

			this.setState(
				{
					exibeModalConfirmacao: true,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao();
			this.fecharModais();
		}

		executaAndamento (url, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;

			const options = {
				method: 'put',
				url,
				data: solicitacao,
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}


		deferirSolicitacao() {
			const mensagemSucesso = "Solicitação de cadastro de usuário deferida com sucesso.";
			const mensagemErro = "Não foi possível deferir a solicitação de cadastro de usuário.";
			const url = '/api/auto-cadastro-usuario/deferir';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacao() {
			const mensagemSucesso = "Solicitação de cadastro de usuário rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de cadastro de usuário.";
			const url = '/api/auto-cadastro-usuario/rejeitar';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

	}


) // redux
); // router